import { Divider } from 'antd';

import BaseConfigItems from '@Enum/BaseConfigItems.enum';
import { ReactComponent as CheckIcon } from '@Icons/appsMenu/check-blue.svg';
import { ReactComponent as HomeDefault } from '@Icons/appsMenu/home.svg';
import { ReactComponent as HomeBlue } from '@Icons/appsMenu/home-blue.svg';

import styles from './apps-popover-content.module.css';

export const getHomeIcon = (
  menuItemTitle: string,
  isSelected: boolean
): JSX.Element | null => {
  if (menuItemTitle !== BaseConfigItems.DASHBOARD) {
    return null;
  }

  const icon = isSelected ? (
    <HomeBlue className={styles.homeIcon} />
  ) : (
    <HomeDefault className={styles.homeIcon} />
  );
  return icon;
};

export const getCheckIcon = (isSelected: boolean): JSX.Element | null => {
  if (!isSelected) {
    return null;
  }

  return <CheckIcon />;
};

export const getDivider = (menuItemTitle: string): JSX.Element | null => {
  if (menuItemTitle !== BaseConfigItems.DASHBOARD) {
    return null;
  }

  return <Divider className={styles.divider} />;
};
